import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-warning',
    templateUrl: './warning.component.html',
    styleUrls: ['./warning.component.scss'],
})
export class WarningComponent {

    @Input() text: string;
    @Input() headerLeft: string;
    @Input() headerRight: string;
    @Input() color: string = 'medium';
    @Input() icon: string | null = 'haleo-error';
    @Input() lateCancellation: boolean;
    @Input() horizontalMargin: boolean = true;
}
